import { Link } from "react-router-dom";

// Logo files live in /public/brand (generated from the supplied LineGone logo).
const SRC = {
  stacked: "/brand/logo-stacked.png",
  horizontal: "/brand/logo-horizontal.png",
  icon: "/brand/icon-192.png",
};

export const TAGLINE = "Order. Do other things. Get pinged.";
export const TaglineText = () => TAGLINE.split(/(?<=\.) /).map((p, i) => <span key={p}>{i > 0 && " "}<span className="inline-block whitespace-nowrap">{p}</span></span>);

export const LogoStacked = ({ className = "w-56" }) => (
  <img src={SRC.stacked} alt="LineGone" className={className} data-testid="logo-stacked" />
);

export const LogoHorizontal = ({ className = "h-8" }) => (
  <img src={SRC.horizontal} alt="LineGone" className={`${className} w-auto`} data-testid="logo-horizontal" />
);

export const LogoIcon = ({ className = "h-10 w-10" }) => (
  <img src={SRC.icon} alt="LineGone icon" className={className} data-testid="logo-icon" />
);

export const HeaderLogo = ({ to = "/", className }) => (
  <Link to={to} aria-label="LineGone home" data-testid="header-logo-link">
    <LogoHorizontal className={className || "h-7 sm:h-8"} />
  </Link>
);
